import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from 'src/app.config';
import { Inject } from '@angular/core';
import { SessionService } from './session.service';

@Injectable({
    providedIn: 'root',
})
export class PolicyDetailsService {
    private httpClient = inject(HttpClient);
    private sessionService = inject(SessionService);
    constructor(@Inject(APP_CONFIG) private config: AppConfig) {}

    private get apiHeaders() {
        return new HttpHeaders({ 'x-api-key': this.config.policyOrchestratorApiKey });
    }

    /**
     * Builds the orchestrator headers, attaching the third-party `sessionId`
     * header when a session is available. The `sessionId` is resolved from the
     * request body first (the third-party login/guard supply it there) and
     * falls back to the stored TP session. When a `sessionId` header is added,
     * the value is stored so subsequent data calls can reuse it.
     */
    private buildHeaders(data: any, extra?: Record<string, string>): HttpHeaders {
        let headers = this.apiHeaders;

        const sessionId = data?.sessionId ?? this.sessionService.getSessionId();
        if (sessionId) {
            this.sessionService.setSessionId(sessionId);
            headers = headers.set('sessionId', sessionId);
        }

        if (extra) {
            for (const [key, value] of Object.entries(extra)) {
                headers = headers.set(key, value);
            }
        }

        return headers;
    }

    getPolicyData(data: any): Observable<any> {
        return this.httpClient.post(this.config.policyOrchestratorUrl, data, { headers: this.buildHeaders(data) });
    }
    getPolicyDataSilent(data: any): Observable<any> {
        const headers = this.buildHeaders(data, { 'X-Skip-Error-Toast': 'true' });
        return this.httpClient.post(this.config.policyOrchestratorUrl, data, { headers });
    }

    // getDCPolicyData(data: any): Observable<any> {
    //     return this.httpClient.post(this.config.getPolicyDataURL, data);
    // }

    // getDCBillingData(data: any): Observable<any> {
    //     return this.httpClient.post(this.config.getPolicyDataURL, data);
    // }
}
